// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum SEND_VERIFY_ACCOUNT_EMAIL_STATUS {
    sent = 'sent',
    failed = 'failed',
    recentlySentInNewAccountEmail = 'recently-sent-in-new-account-email',
}
